import React from 'react';
import { useI18n } from '../../context/I18nContext';
import { LOCALE_OPTIONS } from '../../i18n';

export default function LanguageSelect({ className = '' }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <label className={`inline-flex items-center gap-2 text-sm ${className}`}>
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        aria-label={t('common.language')}
        title={t('common.language')}
        className="border border-stone-200 dark:border-[#3a3a52] bg-white dark:bg-[#252535] text-stone-800 dark:text-stone-100 rounded-lg px-2 py-1 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-stone-400 dark:focus:ring-stone-500"
      >
        {LOCALE_OPTIONS.map((o) => (
          <option key={o.code} value={o.code}>
            {o.short}
          </option>
        ))}
      </select>
    </label>
  );
}
